import axios from 'axios'

// use the main class, no need to load the plugin here
import AppConfig from '../plugins/config/AppConfig'
import SessionHelper from '../helpers/SessionHelper'

let secureInstance = null
let secureInstanceMultipart = null

function handleUnauthorized() {
  SessionHelper.clear()
  if (window.location.pathname !== '/auth/login') {
    window.location.href = '/auth/login'
  }
}

function attachUnauthorizedInterceptor(instance) {
  instance.interceptors.response.use(
    response => response,
    error => {
      if (error && error.response && error.response.status === 401) {
        handleUnauthorized()
      }
      return Promise.reject(error)
    }
  )
}

class TransitApi {
  constructor() {
    const config = AppConfig.load()

    this.props = {
      baseURL: config.API_URL,
    }
  }

  getInstance() {
    return axios.create(this.props)
  }

  getSecureInstance() {
    if (secureInstance === null) {
      secureInstance = axios.create(this.props)
      secureInstance.interceptors.request.use(
        config => {
          config.headers = this.getAuthHeaders() // eslint-disable-line no-param-reassign
          return config
        },
        error => Promise.reject(error)
      )
      attachUnauthorizedInterceptor(secureInstance)
      return secureInstance
    }
    return secureInstance
  }

  getSecureInstanceMultipart() {
    if (secureInstanceMultipart === null) {
      secureInstanceMultipart = axios.create(this.props)
      secureInstanceMultipart.interceptors.request.use(
        config => {
          config.headers = this.getAuthHeadersMultipart() // eslint-disable-line no-param-reassign
          return config
        },
        error => Promise.reject(error)
      )
      attachUnauthorizedInterceptor(secureInstanceMultipart)
      return secureInstanceMultipart
    }
    return secureInstanceMultipart
  }

  getAuthHeaders() {
    this.headers = {}
    const token = localStorage.getItem('token')
    if (token !== null) {
      this.headers = {
        'content-type': 'application/json;charset=UTF-8',
        Authorization: `Bearer ${token}`,
      }
    }
    return this.headers
  }

  getAuthHeadersMultipart() {
    this.headers = {}
    const token = localStorage.getItem('token')
    if (token !== null) {
      this.headers = {
        'content-type': 'multipart/form-data;charset=UTF-8',
        Authorization: `Bearer ${token}`,
      }
    }
    return this.headers
  }

  getQueryString(params) {
    this.qs = Object.keys(params)
      .map(
        key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
      )
      .join('&')
    return this.qs
  }
}

export default new TransitApi()
